import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "custom-option" }
const _hoisted_3 = {
  key: 0,
  class: "custom-option__tips ml-3"
}

import type { StringKeyObject } from "@/types/global";

import type {
  ConfigFormType,
  ExposeType,
  AntType,
  Rule,
} from "@/components/form";

import type { FormProps } from "ant-design-vue";

import { Form, Row, Col, Input } from "ant-design-vue";

import {
  ref,
  toRefs,
  unref,
  watch,
  defineAsyncComponent,
} from "vue";

import { cloneDeep } from "lodash-es";

interface RulesType {
  [key: string]: Rule[];
}

interface Props {
  configData: ConfigFormType;
  configLayout?: {
    labelCol?: FormProps["labelCol"];
    wrapperCol?: FormProps["wrapperCol"];
  };
  /** 表单 autocomplete，默认 'off'。授权密码等需浏览器保存/填充时传 'on' */
  autocomplete?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    configData: {},
    configLayout: {},
    autocomplete: {}
  },
  setup(__props: any, { expose: __expose }) {

const Select = defineAsyncComponent(() => import("ant-design-vue/es/select"));

const DatePicker = defineAsyncComponent(
  () => import("ant-design-vue/es/date-picker")
);

const Cascader = defineAsyncComponent(
  () => import("ant-design-vue/es/cascader")
);

const TreeSelect = defineAsyncComponent(
  () => import("ant-design-vue/es/tree-select")
);

const Radio = defineAsyncComponent(() => import("ant-design-vue/es/radio"));

const UploadImg = defineAsyncComponent(
  () => import("@/components/uploadImg/index.vue")
);

const Upload = defineAsyncComponent(
  () => import("@/components/upload/index.vue")
);

const GroupCom = Radio.Group;

const prop = __props;

const { configData, configLayout } = toRefs(prop);

const getPrefix = (type: AntType): string => {
  let prefix = "";
  switch (type) {
    case "input":
      prefix = "请填写";
      break;
    case "inputPassword":
      prefix = "请输入";
      break;
    case "select":
      prefix = "请选择";
      break;
    case "datePicker":
      prefix = "请选择";
      break;
    case "textArea":
      prefix = "请填写";
      break;
    case "cascader":
      prefix = "请选择";
      break;
    case "treeSelect":
      prefix = "请选择";
      break;
    case "uploadImg":
      prefix = "请上传";
      break;
    case "upload":
      prefix = "请上传";
      break;
    case "radioGroup":
      prefix = "请选择";
      break;
  }
  return prefix;
};

const getFormData = (): StringKeyObject => {
  const keys = Object.keys(configData.value);
  const data: StringKeyObject = {};
  keys.forEach((i) => {
    data[i] = configData.value[i].value;
  });
  return data;
};

const getRules = (): RulesType => {
  const keys = Object.keys(configData.value);
  const data: RulesType = {};
  keys.forEach((i) => {
    if (configData.value[i]?.hidden) {
      return;
    }
    const rules = configData.value[i].rules;
    if (Array.isArray(rules) && rules.length) {
      // 自动生成message
      if (!rules[0].message && !rules[0].validator) {
        const text = `${getPrefix(configData.value[i].antType)}${
          configData.value[i].label
        }`;
        rules[0].message = text;
      }
      data[i] = rules;
    }
  });
  return data;
};

const labelCol = configLayout?.value?.labelCol || {};

const wrapperCol = configLayout?.value?.wrapperCol || {};

const FormData = ref(getFormData());

const rulesRef = ref(getRules());

const keys = ref(Object.keys(configData.value));

const { validateInfos, validate: validateForm } = Form.useForm(
  FormData,
  rulesRef
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const validate: <T = any>() => Promise<T> = () => {
  return new Promise((resolve, reject) => {
    validateForm()
      .then((res) => resolve(cloneDeep(unref(FormData.value) as typeof res)))
      .catch((e) => {
        reject(e);
      });
  });
};

watch(
  () => FormData.value,
  () => {
    keys.value.forEach((i) => {
      configData.value[i].value = FormData.value[i];
    });
  },
  { deep: true }
);

watch(
  () => configData.value,
  () => {
    FormData.value = getFormData();
    rulesRef.value = getRules();
  },
  { deep: true }
);

__expose<ExposeType>({
  validate,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    "label-col": _unref(labelCol),
    "wrapper-col": _unref(wrapperCol),
    "validate-trigger": ['blur', 'change'],
    autocomplete: _ctx.autocomplete ?? 'off'
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Row), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keys.value, (i) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (!_unref(configData)[i].hidden)
                ? (_openBlock(), _createBlock(_unref(Col), {
                    key: i,
                    span: _unref(configData)[i].span || 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Form).Item, _mergeProps({
                        label: _unref(configData)[i].label,
                        extra: _unref(configData)[i].extra || ''
                      }, { ref_for: true }, _unref(validateInfos)[i]), {
                        default: _withCtx(() => [
                          (_unref(configData)[i].antType === 'text')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(FormData.value[i] || "--"), 1))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'input')
                            ? (_openBlock(), _createBlock(_unref(Input), _mergeProps({
                                key: 1,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event),
                                placeholder: `${getPrefix(_unref(configData)[i].antType)}${
                _unref(configData)[i].label
              }`,
                                maxlength: 100
                              }, { ref_for: true }, _unref(configData)[i].bind), null, 16, ["value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'textArea')
                            ? (_openBlock(), _createBlock(_unref(Input).TextArea, _mergeProps({
                                key: 2,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event),
                                placeholder: "不超过300字",
                                "show-count": "",
                                maxlength: 300
                              }, { ref_for: true }, _unref(configData)[i].textAreaBind), null, 16, ["value", "onUpdate:value"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'inputPassword')
                            ? (_openBlock(), _createBlock(_unref(Input).Password, _mergeProps({
                                key: 3,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event),
                                placeholder: `${getPrefix(_unref(configData)[i].antType)}${
                _unref(configData)[i].label
              }`
                              }, { ref_for: true }, _unref(configData)[i].bind), null, 16, ["value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'select')
                            ? (_openBlock(), _createBlock(_unref(Select), _mergeProps({
                                key: 4,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event),
                                placeholder: `${getPrefix(_unref(configData)[i].antType)}${
                _unref(configData)[i].label
              }`,
                                "allow-clear": ""
                              }, { ref_for: true }, _unref(configData)[i].bind), {
                                option: _withCtx((option) => [
                                  _createElementVNode("span", _hoisted_2, [
                                    _createTextVNode(_toDisplayString(_unref(configData)[i].bind?.fieldNames?.label
                      ? option[_unref(configData)[i].bind?.fieldNames?.label || "label"]
                      : option["label"]) + " ", 1),
                                    (option.tips)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(option.tips), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1040, ["value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'datePicker')
                            ? (_openBlock(), _createBlock(_unref(DatePicker), _mergeProps({
                                key: 5,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event),
                                placeholder: `${getPrefix(_unref(configData)[i].antType)}${
                _unref(configData)[i].label
              }`
                              }, { ref_for: true }, _unref(configData)[i].datePickerBind, { class: "w100" }), null, 16, ["value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'upload')
                            ? (_openBlock(), _createBlock(_unref(Upload), _mergeProps({
                                key: 6,
                                "file-list": FormData.value[i],
                                "onUpdate:fileList": ($event: any) => ((FormData.value[i]) = $event)
                              }, { ref_for: true }, _unref(configData)[i].uploadBind), null, 16, ["file-list", "onUpdate:fileList"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'uploadImg')
                            ? (_openBlock(), _createBlock(_unref(UploadImg), {
                                key: 7,
                                "file-list": FormData.value[i],
                                "onUpdate:fileList": ($event: any) => ((FormData.value[i]) = $event)
                              }, null, 8, ["file-list", "onUpdate:fileList"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'cascader')
                            ? (_openBlock(), _createBlock(_unref(Cascader), _mergeProps({
                                key: 8,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event),
                                placeholder: `${getPrefix(_unref(configData)[i].antType)}${
                _unref(configData)[i].label
              }`
                              }, { ref_for: true }, _unref(configData)[i].cascaderBind), null, 16, ["value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'treeSelect')
                            ? (_openBlock(), _createBlock(_unref(TreeSelect), _mergeProps({
                                key: 9,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event),
                                "allow-clear": "",
                                "tree-default-expand-all": "",
                                placeholder: `${getPrefix(_unref(configData)[i].antType)}${
                _unref(configData)[i].label
              }`
                              }, { ref_for: true }, _unref(configData)[i].treeSelectBind), null, 16, ["value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true),
                          (_unref(configData)[i].antType === 'radioGroup')
                            ? (_openBlock(), _createBlock(_unref(GroupCom), _mergeProps({
                                key: 10,
                                value: FormData.value[i],
                                "onUpdate:value": ($event: any) => ((FormData.value[i]) = $event)
                              }, { ref_for: true }, _unref(configData)[i].radioGroupBind), null, 16, ["value", "onUpdate:value"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1040, ["label", "extra"])
                    ]),
                    _: 2
                  }, 1032, ["span"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label-col", "wrapper-col", "autocomplete"]))
}
}

})